import * as Sentry from "@sentry/react";
import React from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

import { envName } from "./util/functions";

// defaults to true if VITE_SENTRY_ENABLED is unset
const SENTRY_ENABLED =
  (import.meta.env.VITE_SENTRY_ENABLED ?? "true").toLowerCase() === "true";

// defaults to 100% (1.0) if VITE_SENTRY_REPLAY_SAMPLE_RATE is unset
const REPLAY_SAMPLE_RATE = parseFloat(
  import.meta.env.VITE_SENTRY_REPLAY_SAMPLE_RATE ?? "1.0",
);

// Sentry monitoring config
Sentry.init({
  enabled: SENTRY_ENABLED,
  environment: envName(import.meta.env.VITE_REGEN_ENDPOINT),
  dsn: import.meta.env.VITE_SENTRY_DSN,
  tunnel: import.meta.env.VITE_SENTRY_TUNNEL,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      maskAllInputs: false,
      maskAllText: false,
      blockAllMedia: false,
      networkDetailAllowUrls: [
        window.location.origin,
        import.meta.env.VITE_REGEN_ENDPOINT,
      ],
    }),
    Sentry.replayCanvasIntegration(),
  ],
  transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set `tracePropagationTargets` to control which URLs distributed
  // tracing should be enabled for
  tracePropagationTargets: [
    new RegExp(`^${import.meta.env.VITE_REGEN_ENDPOINT}`),
  ],
  // Session Replay
  // 1.0 sets the sample rate to 100%. May want the `replaysSessionSampleRate`
  // to be lower in production (e.g. 10%, or 0.1)
  replaysSessionSampleRate: REPLAY_SAMPLE_RATE,
  replaysOnErrorSampleRate: 1.0,
});
